import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "list shadow" }

import { ref } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BaseList',
  props: {
    listItems: {}
  },
  setup(__props: any) {

const props = __props
    const list = ref(props.listItems)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "list-item source-code-pro-400",
        key: index
      }, " > " + _toDisplayString(item), 1))
    }), 128))
  ]))
}
}

})